import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { portalSelectStyles } from '../../../../theme/selectStyles';
import {
  ensureShortlist,
  toggleShortlistPlayer,
} from '../../../../redux/actions/Shortlist';
import {
  getShortlistInitialized,
  getShortlistLoading,
  isPlayerShortlisted,
} from '../../../../redux/selector/Shortlist';
import {
  ActionSelectMenuGlobal,
  ActionOptionLabel,
  StyledButtonContainer,
  StyledSelectContainer,
  StyledActionSelect,
} from './styled';

const menuPortalTarget = typeof document !== 'undefined' ? document.body : null;

const ActionIcon = ({ type, active = false }) => {
  if (type === 'buy') {
    return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 13 13 20l-9-9V4h7l9 9Z" /><circle cx="8.5" cy="8.5" r="1.2" /></svg>;
  }
  if (type === 'loan') {
    return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7 7-4 4 4 4M3 11h13M17 9l4 4-4 4M21 13H8" /></svg>;
  }
  if (type === 'scout') {
    return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6" /><path d="m16 16 4 4" /></svg>;
  }
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill={active ? 'currentColor' : 'none'}>
      <path d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8-6.2-3.2L5.8 21 7 14.2l-5-4.9 6.9-1L12 2Z" />
    </svg>
  );
};

const optionLabel = (icon, label, active = false) => (
  <ActionOptionLabel $active={active}>
    <ActionIcon type={icon} active={active} />
    <span>{label}</span>
  </ActionOptionLabel>
);

const ActionCell = ({ cell, openSignPopup, openLoanPopup, openScoutPopup }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const playerId = cell.row.original._id;
  const isShortlisted = useSelector(isPlayerShortlisted(playerId));
  const shortlistInitialized = useSelector(getShortlistInitialized);
  const shortlistLoading = useSelector(getShortlistLoading);
  const isFreeAgent = cell.row.original.teamName === 'Free agent';
  const isActionsDisabled = cell.row.original?.academy?.status === 1;

  React.useEffect(() => {
    if (!shortlistInitialized && !shortlistLoading) {
      dispatch(ensureShortlist());
    }
  }, [dispatch, shortlistInitialized, shortlistLoading]);

  const options = [
    {
      label: optionLabel('buy', isFreeAgent ? 'Sign free agent' : 'Buy offer'),
      value: 'buyOffer',
    },
    isFreeAgent
      ? { label: optionLabel('scout', 'Scout'), value: 'scoutRequest' }
      : { label: optionLabel('loan', 'Loan offer'), value: 'loanOffer' },
    {
      label: optionLabel(
        'shortlist',
        isShortlisted ? 'Remove from shortlist' : 'Add to shortlist',
        isShortlisted
      ),
      value: 'shortlist',
    },
  ];
  const openWindow = (e) => {
    const requestName = e.value;
    if (requestName === 'buyOffer') {
      openSignPopup();
    }
    if (requestName === 'loanOffer') {
      openLoanPopup();
    }
    if (requestName === 'scoutRequest') {
      openScoutPopup();
    }
    if (requestName === 'shortlist') {
      dispatch(toggleShortlistPlayer(playerId));
    }
    if (requestName === 'managerInfo') {
      window.open(
        `https://discordapp.com/users/${cell.row.original.managerId}`,
        '_blank'
      );
    }
  };
  return (
    <StyledButtonContainer
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <ActionSelectMenuGlobal />
      <StyledSelectContainer className="action-cell">
        <StyledActionSelect
          isDisabled={isActionsDisabled}
          value={null}
          isOptionDisabled={(option) => option.disabled}
          onChange={(e) => openWindow(e)}
          options={options}
          isSearchable={false}
          menuPlacement="auto"
          menuPosition="fixed"
          menuPortalTarget={menuPortalTarget}
          menuShouldScrollIntoView={false}
          placeholder="Action"
          classNamePrefix="action-select"
          styles={portalSelectStyles(theme, 40)}
        />
      </StyledSelectContainer>
    </StyledButtonContainer>
  );
};
export default React.memo(ActionCell);
